import React, { useState } from 'react';
import { Translate, TranslateHTML } from 'core/translate';
import BrandSections from '../BrandSections/BrandSections';
import FilterControls from '../FilterControls/FilterControls';
import { useAppContext } from '../AppContext';
import HeaderTitle from '../HeaderTitle';

const SupplierLinkSection = () => {
  const { country, language, variant } = useAppContext();
  if (country !== 'US' || variant !== 'ff') {
    return null;
  }
  // TODO: This should ultimately come from the server to include the separate domain
  const url = `supplier/${language}/${country}`;
  return (
    <div className="text-center model-selector-list__supplier-link-section">
      <TranslateHTML value="byo.selector.supplier.link.label" />{' '}
      <a href={url}>
        <Translate value="byo.selector.supplier.link.text" />
      </a>
    </div>
  );
};

const SmallScreenTitle = () => (
  <div className="model-selector-list__title show-for-small-only">
    <HeaderTitle />
  </div>
);

const ModelSelectorList = ({ onViewInventoryClicked }) => {
  const { defaultYear } = useAppContext();
  const [year, setYear] = useState(defaultYear);
  const [brand, setBrand] = useState('');
  const [type, setType] = useState('');

  return (
    <div className="model-selector-list">
      <FilterControls
        onYearChange={setYear}
        onBrandChange={setBrand}
        onTypeChange={setType}
        selectedYear={year}
      />
      <div>
        <SmallScreenTitle />
        <SupplierLinkSection />
        <BrandSections
          brandFilter={brand}
          selectedYear={year}
          selectedType={type}
          onViewInventoryClicked={onViewInventoryClicked}
        />
      </div>
    </div>
  );
};

export default ModelSelectorList;
